import gql from 'graphql-tag';

export const RECURRING_SCHEDULE_FRAGMENT = gql`
  fragment RecurringScheduleFragment on RecurringSchedule {
    isRecurring
    recurringSpringSchedule
    recurringSummerSchedule
    recurringFallSchedule
    recurringWinterSchedule
    recurringDaysOfWeekPreference
  }
`;
